/**
 * Block deprecation
 *
 * @see https://developer.wordpress.org/block-editor/reference-guides/block-api/block-deprecation/
 * @see https://developer.wordpress.org/news/2023/03/block-deprecation-a-tutorial/
 */

import { RichText, useBlockProps, useInnerBlocksProps } from '@wordpress/block-editor';
import { filterOutWhiteSpace } from '../utils/general-utils';

const v1 = {
  supports: {
    anchor: true,
    html: false
  },
  attributes: {
    layout: {
      default: 'is-split',
      type: 'string'
    },
    splitHeadingOrientation: {
      default: '',
      type: 'string'
    },
    stackedAlignment: {
      default: '',
      type: 'string'
    },
    baseStyle: {
      default: '',
      type: 'string'
    },
    borderColor: {
      default: '',
      type: 'string'
    },
    borderStyle: {
      default: '',
      type: 'string'
    },
    backgroundColor: {
      default: '',
      type: 'string'
    },
    borderColorFromImageWithText: {
      default: '',
      type: 'string'
    },
    layoutFromImageWithText: {
      default: '',
      type: 'string'
    },
    heading: {
      default: [],
      selector: '.text-with-cta__heading',
      source: 'children',
      type: 'array'
    },
    headingColor: {
      default: '',
      type: 'string'
    },
    text: {
      default: [],
      selector: '.text-with-cta__text',
      source: 'children',
      type: 'array'
    },
    textColor: {
      default: '',
      type: 'string'
    },
    isParentBlock: {
      default: false,
      type: 'boolean'
    }
  },
  save({ attributes }) {
    const {
      layout,
      stackedAlignment,
      splitHeadingOrientation,
      backgroundColor,
      baseStyle,
      borderColor,
      borderStyle,
      layoutFromImageWithText,
      heading,
      headingColor,
      text,
      textColor
    } = attributes;

    const bgColor = layoutFromImageWithText !== 'layered' && backgroundColor ? { backgroundColor } : undefined;
    const colorForBase = baseStyle ? { color: borderColor } : null;

    const blockProps = useBlockProps.save({
      className: 'block__text-with-cta text-black w-full relative',
      style: { ...bgColor, ...colorForBase }

    });

    const { children, ...innerBlocksProps } = useInnerBlocksProps.save(
      { className: 'inner-blocks-wrapper' }
    );

    const isCurved = baseStyle === 'has-curve';
    const curvedBaseWithBorder = ( isCurved && borderColor ) ? 'has-curved-border' : '';

    const blockWrapperClasses = filterOutWhiteSpace( [
      'block-wrapper',
      layout,
      stackedAlignment,
      splitHeadingOrientation,
      baseStyle,
      curvedBaseWithBorder,
      borderStyle
    ] );

    const hColor = headingColor ? { color: headingColor } : undefined;
    const tColor = textColor ? { color: textColor } : undefined;

    return (
      <div { ...blockProps }>
        <div className='text-with-cta--inner'>
          <div className={ blockWrapperClasses }>
            { heading.length > 0 && (
              <RichText.Content
                className='heading-2 text-with-cta__heading text-black break-normal mt-0 mb-24 mx-0'
                style={ { ...hColor } }
                tagName='h2'
                allowedFormats={ [ 'core/bold', 'core/italic' ] }
                value={ heading }
              />
            ) }

            { text.length > 0 && (
              <RichText.Content
                className='paragraph-1 text-with-cta__text text-black break-normal'
                style={ { ...tColor } }
                tagName='p'
                value={ text }
              />
            ) }
            <div { ...innerBlocksProps }>
              { children }
            </div>
          </div>
        </div>
      </div>
    );
  }
};

export default [ v1 ];
